import React from 'react'

import logger from '@/utils/logger'

import { isUserDefined } from '@/client/services/user'

import { defaultUser } from '../internal/constants'
import { UserContext } from '../internal/context'
import type { UserContextType } from '../internal/types'

export { UserContext, defaultUser }
export type { UserContextType }

export function useUser(): UserContextType {
  const contextValue = React.useContext(UserContext)
  if (contextValue == null) {
    logger.error('UserContextType was null, falling back to default value', {
      stack: new Error(),
    })
    return defaultUser
  }

  return contextValue
}

export function useUserRequired(): UserContextType & { id: number } {
  const user = useUser()
  if (!isUserDefined(user)) {
    throw new Error('Unauthorized')
  }
  return user as ReturnType<typeof useUserRequired>
}
